<!-- <div class="ui three column stackable grid">
  <div *appTimes="count" class="column">
    <div class="ui raised segment">
      <div class="ui placeholder">
        <div class="header">
          <div class="short line"></div>
        </div>
        <div class="image paragraph"></div>
        <div class="paragraph">
          <div class="very short line"></div>
          <div class="short line"></div>
        </div>
      </div>
    </div>
  </div>
</div> -->
<!-- 
<div class="timeline-wrapper">
  <div class="timeline-item">
    <div class="animated-background">
      <div class="background-masker header-top"></div>
      <div class="background-masker all-line"></div>
      <div class="background-masker half-line"></div>
      <div class="background-masker small-right"></div>
      <div class="background-masker center-right"></div>
      <div class="background-masker half-line middle"></div>
      <div class="background-masker small-right middle"></div>
      <div class="background-masker center-right middle"></div>
      <div class="background-masker half-line bottom"></div>
      <div class="background-masker small-right bottom"></div>
      <div class="background-masker center-right bottom"></div>
      <div class="background-masker half-line bottom-end"></div>
      <div class="background-masker full-line-bottom"></div>
    </div>
  </div>
</div> -->

<div class="row" style="padding-top: 100px;">
  <div class="col-xl-3-custom col-lg-4 col-md-6 col-sm-12" *appTimes="count">
    <div class="card">
      <div class="animated-background" style="margin: 5px;">
        <div class="background-masker header-top"></div>
        <div class="background-masker all-line"></div>
        <div class="background-masker half-line"></div>
        <div class="background-masker small-right"></div>
        <div class="background-masker center-right"></div>
        <div class="background-masker half-line middle"></div>
        <div class="background-masker small-right middle"></div>
        <div class="background-masker center-right middle"></div>
        <div class="background-masker half-line bottom"></div>
        <div class="background-masker small-right bottom"></div>
        <div class="background-masker center-right bottom"></div>
        <div class="background-masker half-line bottom-end"></div>
        <div class="background-masker full-line-bottom"></div>
      </div>
    </div>
  </div>
</div>